module.exports = __webpack_public_path__ + "media/4.b0e5a4ca.wav";